export const MENSAGENS_ENDERECO = {
  ERRO_BUSCAR_ENDERECO: 'Atenção! Falha ao obter o endereço do cliente, impossível prosseguir.\nPor favor refazer a venda!'
}
